import { render, staticRenderFns } from "./productCertTable.vue?vue&type=template&id=38691e91&"
import script from "./productCertTable.vue?vue&type=script&lang=js&"
export * from "./productCertTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports